var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<pkp-alert type=\"danger\" dismissible=\"true\">\nPlease review your input, some information is missing or of invalid format.\n</pkp-alert>\n";
var id1="app/includes/generalValidationError.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;